var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFarsActFireAndRescue = function SvgFarsActFireAndRescue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fars-act-fire-and-rescue_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF2525",
    d: "m21.508 11.675-3.433-3.433A.834.834 0 0 0 17.483 8h-2.15a.833.833 0 0 0-.833.834V10.5H6.85L17.408 4.56a.833.833 0 0 0-.816-1.45L3.4 10.5A1.666 1.666 0 0 0 2 12.167v4.167A1.667 1.667 0 0 0 3.667 18H4.5a2.5 2.5 0 0 0 5 0h5a2.5 2.5 0 0 0 5 0h.833A1.667 1.667 0 0 0 22 16.334v-3.475a1.668 1.668 0 0 0-.492-1.184"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fars-act-fire-and-rescue_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2 3h20v17.5H2z"
  })))));
};
export default SvgFarsActFireAndRescue;